import { createContext } from 'react';
import last from 'lodash/last';
import { DEFAULT_BREAK_POINTS } from './constant';
const lastBreakPoint = last(DEFAULT_BREAK_POINTS);
// 默认的布局上下文参数
export const defaultContext = {
    prefix: 'cn-layout-',
    noPadding: false,
    sectionGap: undefined,
    blockGap: undefined,
    gridGap: undefined,
    maxNumberOfColumns: lastBreakPoint.numberOfColumns || 12,
    breakPoint: lastBreakPoint,
};
export default createContext(defaultContext);
